import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import OutsideClickHandler from 'react-outside-click-handler'
import { Popup } from 'semantic-ui-react'
import CommentActions, { CommentSelectors } from 'Redux/CommentRedux'
import Avatar from 'Components/Avatar'
import styles from './CommentStreamStyles'

class CommentStream extends Component {
  static propTypes = {
    duration: PropTypes.number,
    comments: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      openPopup: null,
      widthEachSec: 0
    }
  }

  componentDidMount () {
    this.avatarWidth = 30 // Find a way to pick this from css.
    this.avatarHalfWidth = this.avatarWidth / 2
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.duration !== nextProps.duration) {
      const widthEachSec = this.refs.stream.offsetWidth / nextProps.duration
      !isNaN(widthEachSec) && this.setState({ widthEachSec })
    }
  }

  setCurrentComment = (comment) => () => {
    this.setState({ openPopup: comment.id })
    this.props.commentsSetCurrent(comment)
  }

  hidePopup = () => {
    this.setState({ openPopup: null })
  }

  renderComment = (comment, index, comments) => {
    // const offsetWidth = path(, this.refs.stream)
    let left = (this.state.widthEachSec * comment.time) - this.avatarHalfWidth
    if (left < 0) {
      left = 0
    } else if (this.refs.stream.offsetWidth &&
      left > this.refs.stream.offsetWidth - this.avatarWidth) {
      left = this.refs.stream.offsetWidth - this.avatarWidth
    }
    const selectedComm = this.props.currentComment.id === comment.id
    const trigger = (
      <div
        className={styles.comment}
        style={{ left }}
        onClick={this.setCurrentComment(comment)}>
        <Avatar
          selected={selectedComm}
          name={comment.name}
          radius={this.avatarWidth}
        />
      </div>
      // {Capitalize(comment.username.slice(2))}
    )
    return (
      <Popup
        position='top left'
        size='mini'
        key={comment.id}
        trigger={trigger}>
        <Popup.Header>{comment.name || comment.email}</Popup.Header>
        <Popup.Content>
          {comment.text}
        </Popup.Content>
      </Popup>
    )
  }

  render () {
    const containerStyle = this.props.comments.length > 0
      ? styles.wrap : styles.noWrap
    return (
      <OutsideClickHandler onOutsideClick={this.hidePopup}>
        <div className={containerStyle} ref='stream'>
          {this.avatarWidth && this.props.comments.map(this.renderComment)}
        </div>
      </OutsideClickHandler>
    )
  }
}

const mapStateToProps = (state) => ({
  currentComment: state.comments.currentComment,
  comments: CommentSelectors.timeLineComments(state)
})

const mapDispatchToProps = (dispatch) => ({
  commentsSetCurrent: (comment) =>
    dispatch(CommentActions.commentsSetCurrent(comment))
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentStream)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CommentStream/CommentStream.js